.secondaryAction {
  display: flex;
  flex-direction: row;
  align-items: center;
  opacity: 0.6;
}

@media (prefers-reduced-motion: no-preference) {
  .secondaryAction {
    transition: opacity 0.2s;
  }
}

.listItemButton {
  padding: 8px;
  background: transparent;
}

:global([data-keyboard-focused]) {
  background-color: var(--tuna-palette-action-selected);
}

/* Prevent double-hover: the parent ListItem handles the full-width
   hover highlight; the inner button should not add its own. */
.listItemButton.listItemButton:hover {
  background-color: transparent;
}

.selfEditDot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: var(--tuna-palette-primary-main);
  opacity: 0.55;
  margin-right: 4px;
  vertical-align: middle;
}

@media (prefers-reduced-motion: no-preference) {
  .selfEditDot {
    transition: opacity 120ms ease-out;
  }
}
